import React from "react";

import { percentage } from "lib/common";
import { sentimentCalc } from "lib/atsent";

import { threadResultType } from "lib/store/dashboard";

import { FaceIcon } from "@atsent/components";

import "./ResultTable.scss";

export type ResultTableProps = {
  cx?: string;
  result: threadResultType;
};

export const ResultTable: React.FC<ResultTableProps> = ({
  cx = "",
  result,
}) => {
  return !!result ? (
    <div className={`ResultTable ${cx}`}>
      <table>
        <thead>
          <tr>
            <th>Feature TAG</th>
            <th>Prob.</th>
            {/*<th>Reason</th>*/}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{result.aspect}</td>
            {/*<td>a</td>*/}
            <td className={"sentiment"}>
              <span>
                {result.sentiment} {percentage(result.sentiment_score, 0)}%
              </span>
              <FaceIcon cx={sentimentCalc(result?.sentiment)} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : null;
};
